<template>
  <v-data-table :headers="headers" :items="ReferralUploads" hide-actions class="elevation-1">
    <template slot="items" slot-scope="props">
      <td>{{ props.item.email }}</td>
      <td>{{ props.item.bank_reference }}</td>
      <td v-if="success(props.item)"><span class="success pa-1 alert">Referral Added</span></td>
      <td v-else>
        <span class="error pa-1 alert">Process Error: {{ props.item.errors[0] }}</span>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'referral-upload-table',
  props: ['ReferralUploads'],
  data: () => ({
    headers: [
      { text: 'Email', align: 'left', sortable: false, value: 'email' },
      { text: 'Your ref', align: 'left', sortable: false, value: 'bank_reference' },
      { text: 'Upload result', align: 'left', sortable: false, value: '' }
    ]
  }),
  methods: {
    success(referral) {
      return _.isUndefined(referral.errors);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep span.test--white {
  color: white !important;
}

::v-deep th:nth-child(n + 2):nth-last-child(n + 2),
td:nth-child(n + 2):nth-last-child(n + 2) {
  /*padding: 0 24px 0 0;*/
}

::v-deep th:last-child,
td:last-child {
  padding: 0 24px 0 0 !important;
}

::v-deep thead {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);

  tr:first-child {
    border-bottom: none !important;
  }
}

::v-deep .small-badge.badge--overlap .badge__badge {
  top: -3px;
  right: -14px;
  font-size: 12px;
  height: 18px;
  width: 18px;
}
</style>
